module.exports = "<div id=\"loader\" class=\"hero text-center\">\n  <div class=\"cp-spinner cp-boxes\"></div>\n  <h4> autenticando...</h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/token/token.component.html
// module id = ./src/app/token/token.component.html
// module chunks = main